import { render } from "./TabChangePassword.vue?vue&type=template&id=837a12ce"
import script from "./TabChangePassword.js?vue&type=script&lang=js"
export * from "./TabChangePassword.js?vue&type=script&lang=js"

import "./TabChangePassword.scss?vue&type=style&index=0&lang=scss&scope=true"
/* custom blocks */
import block0 from "./TabChangePassword.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fpresentation%2Ffashion%2FUser%2FTabChangePassword%2FTabChangePassword.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__